import gql from 'graphql-tag'

export const UPDATE_WORKING_HOURS = gql`
  mutation UpdateWorkingHours($data: WorkingHoursUpdateInput!) {
    updateWorkingHours(data: $data) {
      id
      dayOfWeek
      isClosed
      isOpen24Hours
      slots {
        openTime
        closeTime
      }
    }
  }
`
